module.exports = "https://s.pinimg.com/webapp/style/images/FR@2x-578923de.png";